module.exports = __webpack_public_path__ + "img/analytics-icon.f6bacfea.svg";